import React from 'react'
// import './Loader.css';
import Loader from './Loader.svg';

export default function Spinner() {
    return (
        // Loader
        <div>
            <img src={Loader} alt="" />
        </div>
    )
}
